<template>
  <div class="">
    <PreLoader v-if="isLoading" />
    <ExceptionWithImg
      v-if="exceptionMsg"
      :msg="exceptionMsg"
      :image="exceptionImg"
    />

    <CountryForm
      v-if="!isLoading"
      :countryData="countryData"
      :submitName="$t('add')"
      v-on:addOrUpdateCountry="addOrUpdateCountry"
    />
  </div>
</template>

<script>
import createToastMixin from "@/utils/create-toast-mixin";
import { STATUS } from "@/utils/constants";
import CountryForm from "@/components/settings/settingsOther/countries/CountryForm.vue";
import Country from "@/models/settings/settingsOther/countries/Country";

export default {
  name: "CountryAdd",
  mixins: [createToastMixin],
  components: {
    CountryForm,
  },
  data() {
    return {
      isLoading: false,
      countryData: new Country(),
    };
  },
  methods: {
    async addOrUpdateCountry() {
      this.isLoading = true;
      try {
        let response = await this.countryData.addOrUpdateCountry(
          this.language,
          this.userAuthorizeToken
        );
        if (response.data.status == STATUS.SUCCESS) {
          this.showMsg(response.data.msg, true);
          this.countryData.setInitialValue();
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.showMsg(response.data.msg);
          this.$store.dispatch("logoutUser");
          this.$router.push("/").catch(() => {});
        } else {
          this.showMsg(response.data.msg);
        }
      } catch (e) {
        this.errorCatch();
      }
      this.isLoading = false;
    },
  },
  computed: {},
  async created() {},
};
</script>

<style scoped lang="scss"></style>
